import UserContext from '@context/UserContext';
import UserForm from '@forms/User';
import Sentry from '@integrations/Sentry';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';


type userFormProps = {
  showPassword: boolean;
  showEmail: boolean;
}

type UserDialogArgs = {
  title?: string;
  userContext: UserContext;
  initialValues?: RegisterForm;
  userFormProps: userFormProps;
  onSubmit: (values: guesthouse.User) => Promise<unknown>;
  resolve: (values: guesthouse.User) => void;
  reject: (e?: Error | boolean) => void;
}

const UserDialog: React.FC<UserDialogArgs> = ({
  resolve,
  reject,
  userContext,
  title,
  onSubmit,
  initialValues,
  userFormProps
}) => {
  const [open, setOpen] = useState(true);
  const [error, setError] = useState(null);

  return (
    <UserContext.Provider value={userContext}>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle>
          {title}
        </DialogTitle>

        <DialogContent>
          <UserForm
            initialValues={initialValues}
            error={error}
            submitText="Save"
            onSubmit={(values) => {
              return onSubmit(values)
                .then((values) => {
                  setOpen(false);
                  return values;
                })
                .then(resolve)
                .catch(e => {
                  setError(e.message);
                  Sentry.captureException(e);
                });
            }}
            {...userFormProps}
          />
        </DialogContent>

        <DialogActions style={{ justifyContent: 'center' }}>
          <Button
            size="small"
            onClick={() => {
              setOpen(false);
              reject(false);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </UserContext.Provider>
  );
};

export default UserDialog;
